module.exports = __webpack_public_path__ + "img/tp_solar_100w.03105355.png";